import React, { FC } from 'react'
import {
    LineGraphInsight,
    LineGraphPoint,
} from '@hazadapt-git/public-core-base'
import { Line } from 'react-chartjs-2'
import { ChartData } from 'chart.js/dist/types/index'
import { differenceInMonths } from 'date-fns'
import { format } from 'date-fns-tz'

export interface LineGraphInsightViewProps
    extends Omit<LineGraphInsight, 'headline'> {
    headline: React.ReactNode
}

const msToLabels = (points: LineGraphPoint[]): string[] => {
    const min_date = new Date(
        Math.min(...points.map((p) => new Date(p.interval[0]).getTime()))
    )
    const max_date = new Date(
        Math.max(...points.map((p) => new Date(p.interval[1]).getTime()))
    )
    const labels: string[] = []
    const dateDiff = differenceInMonths(max_date, min_date)
    for (const point of points) {
        const start = new Date(point.interval[0])
        const end = new Date(point.interval[1])
        if (dateDiff >= 24) {
            // year
            labels.push(format(start, 'yyyy'))
        } else if (dateDiff >= 6) {
            // month
            labels.push(format(start, 'MMM yyyy'))
        } else if (dateDiff >= 2) {
            // week
            labels.push(`${format(start, 'MMM d')} - ${format(end, 'MMM d')}`)
        } else {
            // day
            labels.push(`${format(start, 'MMM d')}`)
        }
    }
    return labels
}

export const LineGraphInsightView: FC<LineGraphInsightViewProps> = (
    props: LineGraphInsightViewProps
) => {
    const getLineGraphData = (): ChartData<'line', number[], string> => {
        return {
            labels: msToLabels(props.points),
            datasets: props.lines.map((line) => ({
                label: line.label,
                data: line.values,
                backgroundColor: line.color,
                borderColor: line.color,
            })),
        }
    }

    return (
        <Line
            data={getLineGraphData()}
            options={{
                resizeDelay: 50,
                scales: {
                    x: {
                        title: {
                            display: true,
                            text: props.axes.x,
                        },
                    },
                    y: {
                        title: {
                            display: true,
                            text: props.axes.y,
                        },
                        ticks: {
                            precision: 0,
                        },
                        beginAtZero: true,
                    },
                },
                aspectRatio: 1,
                // maintainAspectRatio: false,
            }}
        />
    )
}
